import Bottega from '@components/Bottegas/Bottega'
import type { BottegaLabels } from '@components/Bottegas/Bottega/Bottega'
import type { BottegaBlock } from '@velasca/types'

export interface BottegasRinascentePageProps {
  labels: BottegaLabels
  blocks: BottegaBlock[]
}

export const BottegasRinascentePage = ({
  labels,
  blocks,
}: BottegasRinascentePageProps) => {
  return (
    <div className="bottega-list col-md-10 col-md-offset-1 mt15">
      {blocks.map((bottega: BottegaBlock) => (
        <Bottega key={bottega.id} labels={labels} bottega={bottega} />
      ))}
    </div>
  )
}
